import React from 'react';
import { useAppSelector } from 'store/Store';
import PropTypes from 'prop-types';

const LightTheme = React.lazy(() => import('./LightTheme'));
const DarkTheme = React.lazy(() => import('./DarkTheme'));

const ThemeSelector = ({ children }) => {
  const isDarkMode = useAppSelector((state) => state.customizer.isDark);
  return (
    <>
      <>{isDarkMode ? <DarkTheme /> : <LightTheme />}</>
      {children}
    </>
  );
};

ThemeSelector.propTypes = {
  children: PropTypes.node,
};

export default ThemeSelector;
